import { Svg } from 'components/svg'
import { IconType } from 'models'

export const IconShare: IconType = () => (
  <Svg viewBox="0 0 24 24">
    <g stroke="currentColor">
      <path d="M5.2 12l13.6-8.2" strokeWidth="1.5"></path>
      <path d="M5.2,12l13.6,8.2" strokeWidth="1.5"></path>
    </g>
    <g fill="currentColor">
      <circle cx="5.2" cy="12" r="3.3"></circle>
      <circle cx="18.8" cy="3.8" r="3.3"></circle>
      <circle cx="18.8" cy="20.2" r="3.3"></circle>
    </g>
  </Svg>
)
